const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function (child) {
  try {
    return originalRemoveChild.call(this, child);
  } catch (err) {
    if (err.name === 'NotFoundError' || err.code === DOMException.NOT_FOUND_ERR) {
      console.warn('Ignored removeChild NotFoundError:', child);
      return child;
    }
    throw err;
  }
};

import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/config';
import reportWebVitals from './reportWebVitals';
import { Spin } from 'antd';
import spinnerGif from './static/img/logo/yerbisn.png';
import './index.css';

Spin.setDefaultIndicator(
  <div
    className="spinner-logo-f"
    style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 8, height: '100%' }}
  >
    <img src={spinnerGif} alt="Yükleniyor..." style={{ width: 'auto', height: '20%', maxHeight: '150px' }} />
    <span style={{ color: '#ff1818', fontSize: 14 }}>Yükleniyor...</span>
  </div>,
);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <>
    <App />
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
